import {
  AUDI_A3_MODEL_IDS,
  AUDI_A4_MODEL_IDS,
  AUDI_A6_MODEL_IDS,
  AUDI_Q3_MODEL_IDS,
  AUDI_Q5_MODEL_IDS,
  BMW_SERIES_3_GLOBAL_MODEL_ID,
  BMW_SERIES_5_GLOBAL_MODEL_ID,
  BMW_X1_MODEL_IDS,
  BMW_X3_MODEL_IDS,
  BMW_X5_MODEL_IDS,
  FORD_FIESTA_MODEL_IDS,
  FORD_FOCUS_MODEL_IDS,
  FORD_KUGA_MODEL_IDS,
  FORD_MONDEO_MODEL_IDS,
  FORD_PUMA_MODEL_IDS,
  GOLF_GLOBAL_MODEL_ID,
  MERCEDES_A_CLASS_MODEL_IDS,
  MERCEDES_C_CLASS_GLOBAL_MODEL_ID,
  MERCEDES_CLA_MODEL_IDS,
  MERCEDES_E_CLASS_GLOBAL_MODEL_ID,
  MERCEDES_GLC_GLOBAL_MODEL_ID,
  OPEL_ASTRA_MODEL_IDS,
  OPEL_CORSA_MODEL_IDS,
  OPEL_INSIGNIA_MODEL_IDS,
  OPEL_MOKKA_MODEL_IDS,
  OPEL_ZAFIRA_MODEL_IDS,
  PASSAT_GLOBAL_MODEL_ID,
  PEUGEOT_2008_MODEL_IDS,
  PEUGEOT_208_MODEL_IDS,
  PEUGEOT_3008_MODEL_IDS,
  PEUGEOT_308_MODEL_IDS,
  PEUGEOT_508_MODEL_IDS,
  POLO_MODEL_IDS,
  RENAULT_CAPTUR_MODEL_IDS,
  RENAULT_CLIO_MODEL_IDS,
  RENAULT_KADJAR_MODEL_IDS,
  RENAULT_MEGANE_MODEL_IDS,
  RENAULT_SCENIC_MODEL_IDS,
  SKODA_FABIA_MODEL_IDS,
  SKODA_KAMIQ_MODEL_IDS,
  SKODA_KODIAQ_MODEL_IDS,
  SKODA_OCTAVIA_MODEL_IDS,
  SKODA_SUPERB_MODEL_IDS,
  TIGUAN_MODEL_IDS,
  TOURAN_MODEL_IDS,
  TOYOTA_AURIS_MODEL_IDS,
  TOYOTA_CHR_MODEL_IDS,
  TOYOTA_COROLLA_MODEL_IDS,
  TOYOTA_RAV_4_MODEL_IDS,
  TOYOTA_YARIS_MODEL_IDS
} from "../../../carModelIds";
import { CategoryNameHr, ModuleNameHr, PageRoute, QueryParam } from "../../../models";
import { stringifyURI } from "../../../services";

export const BRAND_DATA = [
  {
    brand: "Volkswagen",
    makeId: "5e0256e2-75f8-40b8-9825-81d4f0ce6ac9",
    models: [
      {
        name: "Golf",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [GOLF_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`
      },
      {
        name:
          "Passat",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [PASSAT_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`
      },
      {
        name: "Tiguan",

        includeModelIds: TIGUAN_MODEL_IDS,


      },
      {
        name: "Polo",

        includeModelIds: POLO_MODEL_IDS,



      },
      {
        name: "Touran",

        includeModelIds: TOURAN_MODEL_IDS,


      },
    ],
  },
  {
    brand: "BMW",
    makeId: "cb168b9e-e921-4138-98bc-21b39b69208f",
    models: [
      {
        name: "Serija 3",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [BMW_SERIES_3_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`

      },
      {
        name: "Serija 5",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [BMW_SERIES_5_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`

      },
      { name: "X3", includeModelIds: BMW_X3_MODEL_IDS },
      { name: "X5", includeModelIds: BMW_X5_MODEL_IDS },
      { name: "X1", includeModelIds: BMW_X1_MODEL_IDS },
    ],
  },
  {
    brand: "Audi",

    makeId: "45e1ca28-bf47-41c3-9d58-694843984f91",
    models: [
      { name: "A4", includeModelIds: AUDI_A4_MODEL_IDS },
      { name: "A6", includeModelIds: AUDI_A6_MODEL_IDS },
      { name: "A3", includeModelIds: AUDI_A3_MODEL_IDS },
      { name: "Q5", includeModelIds: AUDI_Q5_MODEL_IDS },
      { name: "Q3", includeModelIds: AUDI_Q3_MODEL_IDS },
    ],
  },
  {
    brand: "Mercedes",
    makeId: "6825383a-d7fe-415c-a6df-0facf3330324",

    models: [
      {
        name: "C-klasa",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [MERCEDES_C_CLASS_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`
      },
      {
        name: "E-klasa",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [MERCEDES_E_CLASS_GLOBAL_MODEL_ID],
        }, QueryParam.searchQuery)}`
      },
      { name: "A-klasa", includeModelIds: MERCEDES_A_CLASS_MODEL_IDS },
      {
        name: "GLC",
        customLink: `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: [MERCEDES_GLC_GLOBAL_MODEL_ID],
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`
      },
      { name: "CLA", includeModelIds: MERCEDES_CLA_MODEL_IDS },
    ],
  },
  {
    brand: "Škoda",

    makeId: "5d08a66c-4d0f-4409-8419-90cecc94dbb8",
    models: [
      { name: "Octavia", includeModelIds: SKODA_OCTAVIA_MODEL_IDS },
      { name: "Fabia", includeModelIds: SKODA_FABIA_MODEL_IDS },
      { name: "Superb", includeModelIds: SKODA_SUPERB_MODEL_IDS },
      { name: "Kodiaq", includeModelIds: SKODA_KODIAQ_MODEL_IDS },
      { name: "Kamiq", includeModelIds: SKODA_KAMIQ_MODEL_IDS },
    ],
  },
  {
    brand: "Opel",

    makeId: "89e3bd0f-e451-4c4a-b268-4d1cf47a459a",
    models: [
      { name: "Astra", includeModelIds: OPEL_ASTRA_MODEL_IDS },
      { name: "Corsa", includeModelIds: OPEL_CORSA_MODEL_IDS },
      { name: "Insignia", includeModelIds: OPEL_INSIGNIA_MODEL_IDS },
      { name: "Mokka", includeModelIds: OPEL_MOKKA_MODEL_IDS },
      { name: "Zafira", includeModelIds: OPEL_ZAFIRA_MODEL_IDS },
    ],
  },
  {
    brand: "Renault",

    makeId: "76ec22a9-9a57-4012-a2f4-bcf43d071b40",
    models: [
      { name: "Clio", includeModelIds: RENAULT_CLIO_MODEL_IDS },
      { name: "Megane", includeModelIds: RENAULT_MEGANE_MODEL_IDS },
      { name: "Captur", includeModelIds: RENAULT_CAPTUR_MODEL_IDS },
      { name: "Scenic", includeModelIds: RENAULT_SCENIC_MODEL_IDS },
      { name: "Kadjar", includeModelIds: RENAULT_KADJAR_MODEL_IDS },
    ],
  },
  {
    brand: "Ford",

    makeId: "4c1d960b-09a2-4260-b50d-83ed07ae254e",
    models: [
      { name: "Focus", includeModelIds: FORD_FOCUS_MODEL_IDS },
      { name: "Fiesta", includeModelIds: FORD_FIESTA_MODEL_IDS },
      { name: "Kuga", includeModelIds: FORD_KUGA_MODEL_IDS },
      { name: "Mondeo", includeModelIds: FORD_MONDEO_MODEL_IDS },
      { name: "Puma", includeModelIds: FORD_PUMA_MODEL_IDS },
    ],
  },
  {
    brand: "Peugeot",

    makeId: "1cb4c6ec-d885-48f4-a5aa-2b31bb2d2757",
    models: [
      { name: "308", includeModelIds: PEUGEOT_308_MODEL_IDS },
      { name: "208", includeModelIds: PEUGEOT_208_MODEL_IDS },
      { name: "3008", includeModelIds: PEUGEOT_3008_MODEL_IDS },
      { name: "508", includeModelIds: PEUGEOT_508_MODEL_IDS },
      { name: "2008", includeModelIds: PEUGEOT_2008_MODEL_IDS },
    ],
  },
  {
    brand: "Toyota",

    makeId: "4d76314d-36ac-458b-912e-2bfa6e7f6b29",
    models: [
      { name: "Corolla", includeModelIds: TOYOTA_COROLLA_MODEL_IDS },
      { name: "Yaris", includeModelIds: TOYOTA_YARIS_MODEL_IDS },
      { name: "RAV4", includeModelIds: TOYOTA_RAV_4_MODEL_IDS },
      { name: "Auris", includeModelIds: TOYOTA_AURIS_MODEL_IDS },
      { name: "C-HR", includeModelIds: TOYOTA_CHR_MODEL_IDS },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/containers/ModulePage/CarStatistics/statistics.ts